import { AppShell } from '@/flows/marketplace/components/app-shell.js';
import { BackLink } from '@/flows/marketplace/components/back-link.js';
import { Button } from '@/components/button.js';
import { Card } from '@/flows/marketplace/components/card.js';
import { OrderSummary } from '@/flows/marketplace/components/order-summary.js';
import { PageHero } from '@/flows/marketplace/components/page-hero.js';
import { ProgressBar } from '@/flows/marketplace/components/progress-bar.js';
import { paymentTermsLabel } from '@/lib/formatters.js';
import { findCartLine } from '@/state/pricing.js';
import { activeCartIndex, openPaymentFor, step } from '@/flows/marketplace/state/step.js';

/** The branch point of the per-product loop; reads the decision back before asking. */
export function AddAnother() {
  const index = activeCartIndex.value;
  const line = index === null ? undefined : findCartLine(index);
  if (line === undefined) return null;

  return (
    <AppShell>
      <BackLink onClick={() => openPaymentFor(line.index, 'tiers')} />

      <PageHero title={`${line.tier.product_name} added`} subtitle={paymentTermsLabel(line)} />

      <ProgressBar />

      <Card>
        <div className="sm-stack sm-cta-block">
          <Button onClick={() => (step.value = 'tiers')}>Add another plan</Button>
          <Button variant="secondary" endIcon={null} onClick={() => (step.value = 'customer-info')}>
            Continue to checkout
          </Button>
        </div>
      </Card>

      <OrderSummary />
    </AppShell>
  );
}
